export enum SubscriptionType {
  Email = `email`,
  SlackWebhook = `slack_webhook`,
  SlackChannel = `slack_channel`,
}

export interface EmailSubscription {
  error: any;
  data: {
    recipient: string;
  };
  type: SubscriptionType.Email;
}

export interface SlackWebookSubscription {
  error: SlackWebhookError;
  data: {
    slack_webhook_url: string;
  };
  type: SubscriptionType.SlackWebhook;
}

export interface SlackChannelSubscription {
  data: {
    slack_team_id: string;
    slack_channel_id: string;
    slack_channel_name: string;
  };
  type: SubscriptionType.SlackChannel;
}

export type Subscription = EmailSubscription | SlackWebookSubscription | SlackChannelSubscription;

export enum SlackWebhookError {
  InvalidUrl = `Not a valid Slack webhook url`,
}

export type CustomAlert = {
  bookmarkId: number;
  bookmarkParams?: TODO;
  bookmarkName: string;
  bookmarkType: string;
  bookmarkUnit?: string;
  bookmarkIsValidForAnomalyDetection?: boolean;
  isValid?: boolean;
  condition: CustomAlertCondition;
  creatorId: number;
  creatorName: string;
  frequency: number;
  id: number;
  name: string;
  paused: boolean;
  projectId: number;
  projectName: string;
  subscriptions: Subscription[];
  workspaceId: number;
};

export type CustomAlertCondition = {
  keys: TODO; // can be an array of object or string
  op: string;
  type: string;
  value: number;
  confidence?: number;
  trainingMode?: string;
};
